module.exports = __webpack_public_path__ + "static/media/Koramangala.ae47d09d.jpg";